import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Methode } from './components/Methode';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-sand-100 font-sans text-ink antialiased" data-id="element-0" data-mp="3fbjbj4ny1vvy">
      <Header data-id="element-1" data-mp="2rkdxmv1kddoa" />
      <main data-id="element-2" data-mp="2rlys6knvowm5">
        <Hero data-id="element-3" data-mp="2rlp10tr3kjev" />
        <Services data-id="element-4" data-mp="2rl6t2zv2ogr4" />
        <Methode data-id="element-5" data-mp="2rikmp3jx47ah" />
        <Contact data-id="element-6" data-mp="2mm2nskb9r362" />
      </main>
      <Footer data-id="element-7" data-mp="2mmvkesgikcah" />
    </div>;
}